import { Yup } from 'shared/yup-extended';

export const getEmailListValidationSchema = (input: {
  invalidErrMsg: string;
}): Yup.StringSchema<
  string | undefined,
  Record<string, unknown>,
  string | undefined
> => {
  const { invalidErrMsg } = input;
  return Yup.string().test(
    'is-email-list',
    invalidErrMsg,
    async (value, context) => {
      if (!value) {
        return true;
      }

      const emailList = value
        ? value.split(',').map((email: string) => email.trim())
        : [];

      if (!emailList.length) {
        return true;
      }

      const emailSchema = Yup.string().email().validTLD();

      const isValid = await Promise.all(
        emailList.map((email) => emailSchema.isValid(email)),
      );

      if (isValid.every(Boolean)) {
        return true;
      }

      const firstInvalidIndex = isValid.findIndex((valid) => !valid);
      if (firstInvalidIndex !== -1) {
        return context.createError({
          message: `${invalidErrMsg}: ${emailList[firstInvalidIndex]}`,
        });
      }

      return false;
    },
  );
};
